import React, { useEffect, useState } from "react";

const API = process.env.REACT_APP_API_URL || "";

async function fetchPays() {
  const res = await fetch(`${API}/api/pays_stats`);
  return await res.json();
}

async function savePays(id, form) {
  const res = await fetch(`${API}/api/pays_pays/${id}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/merge-patch+json" },
    body: JSON.stringify(form),
  });
  if (!res.ok) throw new Error("Erreur lors de la modification");
}

async function createPays(form) {
  const res = await fetch(`${API}/api/pays_pays`, {
    method: "POST",
    headers: { "Content-Type": "application/ld+json" },
    body: JSON.stringify(form),
  });
  if (!res.ok) throw new Error("Erreur lors de la création");
}

async function deletePays(id) {
  const res = await fetch(`${API}/api/pays_pays/${id}`, { method: "DELETE" });
  if (!res.ok) throw new Error("Erreur lors de la suppression");
}

const emptyForm = { payCode: "", payLib: "" };

function EditRow({ pays, onSave, onCancel }) {
  const [form, setForm] = useState({
    payCode: pays.payCode || "",
    payLib: pays.payLib || "",
  });

  const inputStyle = { width: "100%", padding: "4px 8px", borderRadius: 4, border: "1px solid #555", background: "#2a2a2a", color: "white" };

  return (
    <tr className="bg-dark">
      <td colSpan="4">
        <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: 10, padding: "10px 0" }}>
          <div>
            <label style={{ color: "white", fontSize: 12, fontWeight: 600 }}>Code</label>
            <input style={inputStyle} value={form.payCode} onChange={e => setForm({ ...form, payCode: e.target.value })} />
          </div>
          <div>
            <label style={{ color: "white", fontSize: 12, fontWeight: 600 }}>Libellé</label>
            <input style={inputStyle} value={form.payLib} onChange={e => setForm({ ...form, payLib: e.target.value })} />
          </div>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <button className="fr-btn" onClick={() => onSave(pays.payId, form)}>Enregistrer</button>
          <button className="fr-btn--secondary" onClick={onCancel}>Annuler</button>
        </div>
      </td>
    </tr>
  );
}

function AddRow({ onSave, onCancel }) {
  const [form, setForm] = useState(emptyForm);
  const inputStyle = { width: "100%", padding: "4px 8px", borderRadius: 4, border: "1px solid #ccc" };

  return (
    <tr style={{ background: "#f0f9ff" }}>
      <td colSpan="4">
        <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: 10, padding: "10px 0" }}>
          <div>
            <label style={{ fontSize: 12, fontWeight: 600 }}>Code</label>
            <input style={inputStyle} placeholder="ex: FR" value={form.payCode} onChange={e => setForm({ ...form, payCode: e.target.value })} />
          </div>
          <div>
            <label style={{ fontSize: 12, fontWeight: 600 }}>Libellé</label>
            <input style={inputStyle} placeholder="ex: France" value={form.payLib} onChange={e => setForm({ ...form, payLib: e.target.value })} />
          </div>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <button className="fr-btn" onClick={() => onSave(form)}>Créer</button>
          <button className="fr-btn--secondary" onClick={onCancel}>Annuler</button>
        </div>
      </td>
    </tr>
  );
}

export default function PaysGeoList() {
  const [pays, setPays] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [adding, setAdding] = useState(false);
  const [search, setSearch] = useState("");
  const [message, setMessage] = useState(null);

  const load = async () => {
    const data = await fetchPays();
    setPays(data);
  };

  useEffect(() => { load(); }, []);

  const notify = (msg) => {
    setMessage(msg);
    setTimeout(() => setMessage(null), 3000);
  };

  const handleSave = async (id, form) => {
    try {
      await savePays(id, form);
      setEditingId(null);
      load();
      notify("✅ Origine géographique modifiée");
    } catch (e) {
      notify("❌ " + e.message);
    }
  };

  const handleCreate = async (form) => {
    try {
      await createPays(form);
      setAdding(false);
      load();
      notify("✅ Origine géographique créée");
    } catch (e) {
      notify("❌ " + e.message);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Supprimer cette origine géographique ?")) return;
    try {
      await deletePays(id);
      load();
      notify("✅ Origine géographique supprimée");
    } catch (e) {
      notify("❌ " + e.message);
    }
  };

  const filtered = pays.filter(p =>
    [p.payCode, p.payLib].some(v => (v || "").toLowerCase().includes(search.toLowerCase()))
  );

  return (
    <div className="admin-page">
      <div className="row w-full admin-page-header">
        <div className="col">
          <h2 className="card-title mb-0">Gestion des origines géographiques</h2>
          <p className="text-secondary m-0">{pays.length} origine(s) enregistrée(s) — {pays.filter(p => p.nbTermes === 0).length} supprimable(s)</p>
        </div>
        <div className="col-md-auto col-sm-12">
          <div className="ms-auto d-flex flex-wrap btn-list" style={{ gap: 8 }}>
            <div className="input-group input-group-flat w-auto">
              <span className="input-group-text">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-1">
                  <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"></path>
                  <path d="M21 21l-6 -6"></path>
                </svg>
              </span>
              <input type="text" className="form-control" placeholder="Rechercher..." value={search} onChange={e => setSearch(e.target.value)} autoComplete="off" />
            </div>
            <button className="fr-btn" onClick={() => { setAdding(true); setEditingId(null); }}>
              + Nouveau
            </button>
          </div>
        </div>
      </div>

      {message && (
        <div style={{ marginBottom: 12, padding: "8px 14px", borderRadius: 6, background: message.startsWith("✅") ? "#dcfce7" : "#fee2e2", color: message.startsWith("✅") ? "#166534" : "#991b1b" }}>
          {message}
        </div>
      )}

      <div className="table-responsive">
        <table className="table table-vcenter table-selectable">
          <thead>
            <tr>
              <th className="admin-table-th">Code</th>
              <th className="admin-table-th">Libellé</th>
              <th className="admin-table-th">Fiches</th>
              <th className="admin-table-th">Actions</th>
            </tr>
          </thead>
          <tbody>
            {adding && (
              <AddRow onSave={handleCreate} onCancel={() => setAdding(false)} />
            )}
            {filtered.map(p => (
              <React.Fragment key={p.payId}>
                <tr>
                  <td className="admin-table-td"><span style={{ fontWeight: 600 }}>{p.payCode}</span></td>
                  <td className="admin-table-td">{p.payLib}</td>
                  <td className="admin-table-td">
                    <span style={{ fontSize: 13, color: "#374151" }}>
                      {p.nbFiches > 0 ? p.nbFiches : "—"}
                    </span>
                  </td>
                  <td className="admin-table-td" style={{ whiteSpace: "nowrap" }}>
                    <span style={{ fontSize: 11, color: "#6b7280", marginRight: 8 }}>
                      {p.nbTermes > 0 ? `${p.nbTermes} terme(s)` : "—"}
                    </span>
                    <button className="fr-btn--secondary" onClick={() => { setEditingId(p.payId); setAdding(false); }}>
                      Modifier
                    </button>
                    {p.nbTermes === 0 && (
                      <button className="fr-btn--danger" style={{ marginLeft: 6 }} onClick={() => handleDelete(p.payId)}>
                        Supprimer
                      </button>
                    )}
                  </td>
                </tr>
                {editingId === p.payId && (
                  <EditRow pays={p} onSave={handleSave} onCancel={() => setEditingId(null)} />
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
